export const draftPersister = (store) => (next) => (action) => {
  const result = next(action);

  try {
    const state = store.getState().cart;

    // ---- ACTIONS THAT MUST SAVE EVEN IF EMPTY ----
    const forceSaveActions = [
      "cart/removeOrderCustomer",
      "cart/clearDiscount",
      "cart/removeNote",
      "cart/clearPendingItems",
    ];

    // If this action is in the forced list → save even if empty
    const mustForceSave = forceSaveActions.includes(action.type);

    // ---- NORMAL EMPTY CHECK ----
    const isCartEmpty =
      !state.selectedTable?.table?.table_name &&
      !state.orderType &&
      !state.customerDetails?.name &&
      (!state.menuItems || state.menuItems.length === 0) &&
      (!state.discount || !state.discount.type);

    if (isCartEmpty && !mustForceSave) {
      // normal case: don't save
      return result;
    }

    // ---- ACTIONS THAT ARE ALLOWED TO TRIGGER SAVE ----
    const allowedPrefixes = [
      "cart/addItem",
      "cart/removeItem",
      "cart/updateItem",
      "cart/addNote",
      "cart/removeNote",
      "cart/selectTable",
      "cart/setDiscount",
      "cart/clearDiscount",
      "cart/setOrderType",
      "cart/setCustomerDetails",
      "cart/removeOrderCustomer",
      "cart/clearPendingItems",
    ];

    const isAllowed = allowedPrefixes.some((prefix) =>
      action.type.startsWith(prefix)
    );

    if (!isAllowed) return result;

    // ---- SAVE THE DRAFT ----
    const draft = {
      selectedTable: state.selectedTable,
      orderType: state.orderType,
      customerDetails: state.customerDetails,
      discount: state.discount,
      pendingItems: state.pendingItems,
    };

    localStorage.setItem("draft_order", JSON.stringify(draft));
  } catch (e) {
    console.error("Draft save failed", e);
  }

  return result;
};
